import { Channel } from './apis';

export interface LayoutData {
  template: string;
  css?: string;
  js?: string;
}

export type CampaignCardProps = CampaignCardPropsWithChannelInfo | CampaignCardPropsWithChannelUuid;

export type TokenInput = string | ((campaignId: number) => Promise<string>);

interface BaseCampaignCardProps {
  id: string;
  layoutId?: string;
  openType: CampaignCardOpenType;
  className?: string;
  programId?: string; // this was added for PF usage because
  token?: TokenInput; // function is dropped during JSON.stringify in reactBoostrap
  document?: Document;
  locale?: string;
  campaignFeedApiHost?: string;
  // Widget-level overrides (Level 1 in fallback priority)
  overrides?: {
    title?: string;
    image?: string;
    description?: string;
    ctaLabel?: string;
  };
}
interface CampaignCardPropsWithChannelInfo extends BaseCampaignCardProps {
  channelInfo: Channel;
  channelUuid?: undefined;
}

interface CampaignCardPropsWithChannelUuid extends BaseCampaignCardProps {
  channelInfo?: undefined;
  channelUuid: string;
}

export enum CampaignCardOpenType {
  iframe = 'iframe',
  newTab = 'new_tab',
  modal = 'modal',
}
